import { capfirst } from 'journalize';

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office: any) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

const OFFICE_NOTE_SLUGS: { [key: string]: string } = {
  'U.S. Senate': 'us-senate',
  'Attorney General': 'attorney-general',
  'Texas Railroad Commission': 'railroad-commissioner',
  'Lieutenant Governor': 'lieutenant-governor',
  'Texas Court of Criminal Appeals': 'texas-court-of-criminal-appeals',
  'U.S. House': 'us-house',
  'State Board of Education': 'state-board-of-education',
  'Texas Senate': 'texas-senate',
  'Texas House': 'texas-house',
};

export function getNoteKey(contest: any) {
  const slug = OFFICE_NOTE_SLUGS[contest.office] || contest.office_slug;
  if (!slug) return null;
  if (contest.division_type === 'statewide' || !contest.office_division) {
    return slug;
  }
  return `${slug}-district-${contest.office_division}-${contest.party}`;
}

const PARTY_SORT_ORDER = [
  'democrat',
  'republican',
  'libertarian',
  'independent',
  'write-in',
];

export function sort_candidates_by_party(candidates: any) {
  return candidates.sort(
    (a: any, b: any) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

export function determineDistrictTitle(contest: any) {
  return `${contest.office} ${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineDistrictTitleYourRaces(contest: any) {
  return `${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineDistrictTitleRunoff(contest: any) {
  return `${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : 'District ' + contest.office_division
  }`.trim();
}

export function determineContestTitle(contest: any) {
  if (
    contest.division_type === 'statewide' ||
    contest.division_type === 'seat' ||
    contest.division_type === 'class'
  )
    return '';

  return determineDistrictTitleRunoff(contest);
}

export function determineContestTitleYourRaces(contest: any) {
  return determineDistrictTitleYourRaces(contest);
}
